import React from "react";

import Modal from "../../../parts/modal-new";
import useFormValidation from "../../../hooks/useFormValidation";
import { useTranslation } from "react-i18next";

function ChangePasswordModal() {
  const { t } = useTranslation("dashboard");
  const formId = "form-change-password";
  const isValid = useFormValidation(formId);
  return (
    <Modal title={t("changePassword.title")} className={"change-password-wrapper"}>
      <div className="body">
        <form
          id={formId}
          method="POST"
          data-noreset
          action="/actions/user/change-password"
        >
          <label>{t("changePassword.currentPassword")}</label>
          <input
            required
            type="password"
            name="currentPassword"
            className="text-input"
            sz="large"
          />
          <label>{t("changePassword.createNewPassword")}</label>
          <input
            required
            type="password"
            name="password"
            className="text-input"
            sz="large"
          />
          <label>{t("changePassword.confirmNewPassword")}</label>
          <input
            required
            type="password"
            name="confirmPassword"
            className="text-input"
            sz="large"
          />
        </form>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="secondary"
          data-action="cancel"
          href="/actions/refresh?modal="
        >
          {t("common:cancel")}
        </a>
        <button
          data-button-type="primary"
          form="form-change-password"
          type="submit"
          disabled={!isValid}
        >
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
}

export default ChangePasswordModal;
